import { defaultProductionPagination } from '../../constants/consts';

export const GET_FESTIVAL = 'app/Festival/GET_FESTIVAL';
export const SET_FESTIVAL = 'app/Festival/SET_FESTIVAL';
export const GET_PERFORMANCES = 'app/Festival/GET_PERFORMANCES';
export const GET_FESTIVAL_CONTACTS = 'app/Festival/GET_FESTIVAL_CONTACTS';
export const UPDATE_FESTIVAL = 'app/Festival/UPDATE_FESTIVAL';
export const GET_COMPANIES = 'app/Festival/GET_COMPANIES';
export const GET_FESTIVAL_DESCRIPTIONS = 'app/Festival/GET_FESTIVAL_DESCRIPTIONS';
export const CREATE_FESTIVAL_DESCRIPTIONS = 'app/Festival/CREATE_FESTIVAL_DESCRIPTIONS';
export const DELETE_FESTIVAL_DESCRIPTIONS = 'app/Festival/DELETE_FESTIVAL_DESCRIPTIONS';
export const UPDATE_FESTIVAL_DESCRIPTIONS = 'app/Festival/UPDATE_FESTIVAL_DESCRIPTIONS';
export const UPDATE_FESTIVAL_INFO = 'app/Festival/UPDATE_FESTIVAL_INFO';
export const ADD_AND_UPDATE_FESTIVAL_CONTACTS = 'app/Festival/ADD_AND_UPDATE_FESTIVAL_CONTACTS';
export const CLEAR_FESTIVAL_PRODUCTIONS = 'app/Festival/CLEAR_FESTIVAL_PRODUCTIONS';
export const GET_FESTIVAL_VENUES = 'app/Festival/GET_FESTIVAL_VENUES';
export const UPDATE_FESTIVAL_VENUES = 'app/Festival/UPDATE_FESTIVAL_VENUES';
export const SET_INIT_PRODUCTIONS = 'app/Festival/SET_INIT_PRODUCTIONS';

export const PRODUCTIONS_TYPES = {
  published: 'published',
  unpublished: 'unpublished',
};

export const defaultFestivalProductionsPagination = defaultProductionPagination;
